import Vue from 'vue'
import Vuex from 'vuex'

import app from '../main'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    symbols: { 
      "EURUSD" : { "precision": 5 }, 
      "EURGBP" : {}, 
      "GBPUSD" : {}, 
      "EURCHF" : { "precision": 5 }, 
      "USDCHF" : {}, 
      "GBPCHF" : {}, 
      "NZDJPY" : {}, 
      "AUDNZD" : {}, 
      "AUDCAD" : {}, 
      "CADJPY" : {}, 
      "CHFJPY" : {}, 
      "CADCHF" : {}, 
      "AUDUSD" : { "precision": 5 }, 
      "USDJPY" : {}, 
      "BITCOIN" : {}, 
      "LITECOIN" : {}, 
      "BCASH" : {}, 
      "RIPPLE" : {}, 
      "ETHEREUM" : {}
    }      
  },
  mutations: {
    changeLang (state, payload) {
      app.$i18n.locale = payload
      localStorage.setItem('currentLanguage', payload)
    }
  },
  actions: {
    setLang ({ commit }, payload) {
      commit('changeLang', payload)
    }
  },
  modules: {
  }
})
